import { render, staticRenderFns } from "./UyapBagliDegilView.vue?vue&type=template&id=6d9a8928&scoped=true"
import script from "./UyapBagliDegilView.vue?vue&type=script&lang=ts"
export * from "./UyapBagliDegilView.vue?vue&type=script&lang=ts"
import style0 from "./UyapBagliDegilView.vue?vue&type=style&index=0&id=6d9a8928&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d9a8928",
  null
  
)

export default component.exports